// [GEN-AI-ASSISTED]
window.mcb.forms.recaptcha = (function () {
    const _logger = window.mcb.utilities.createLogger("forms.recaptcha");
    var recaptchaLoading = false;
    var recaptchaReady = false;
    var recaptchaLoadError = null;
    var recaptchaLoadTimeout = null;
    var readyCallbacks = [];
    var widgetIds = new Map();

    const notifyReady = function () {
        if (recaptchaLoadTimeout !== null) {
            clearTimeout(recaptchaLoadTimeout);
            recaptchaLoadTimeout = null;
        }

        recaptchaReady = true;
        recaptchaLoading = false;
        _logger.trace("reCAPTCHA is Ready");

        while (readyCallbacks.length > 0) {
            readyCallbacks.shift().resolve();
        }
    };

    const notifyFailed = function (error) {
        if (recaptchaLoadTimeout !== null) {
            clearTimeout(recaptchaLoadTimeout);
            recaptchaLoadTimeout = null;
        }

        recaptchaLoading = false;
        recaptchaLoadError = error;
        _logger.error("reCAPTCHA failed to load", error);

        while (readyCallbacks.length > 0) {
            readyCallbacks.shift().reject(error);
        }
    };

    return _ = {
        load: function (settings) {
            if (settings != null && recaptchaReady === false && recaptchaLoading === false) {
                recaptchaLoading = true;
                recaptchaLoadError = null;

                window.mcbRecaptchaOnLoad = function () {
                    if (typeof window.grecaptcha === 'undefined') {
                        notifyFailed(new Error("reCAPTCHA API was unavailable after loading"));
                        return;
                    }

                    window.grecaptcha.ready(function () {
                        notifyReady();
                    });
                };

                // reCAPTCHA v2 uses ?render=explicit and calls grecaptcha.render() per widget,
                // rather than pre-registering a site key for grecaptcha.execute (v3-only).
                const script = document.createElement('script');
                script.src = 'https://www.google.com/recaptcha/api.js?onload=mcbRecaptchaOnLoad&render=explicit';
                script.async = true;
                script.defer = true;
                script.onerror = function () {
                    notifyFailed(new Error("reCAPTCHA API failed to load"));
                };
                document.head.appendChild(script);
                recaptchaLoadTimeout = setTimeout(function () {
                    notifyFailed(new Error("reCAPTCHA API load timed out"));
                }, 10000);
            }
        },
        isReady: function () {
            return recaptchaReady;
        },
        whenReady: function () {
            return new Promise((resolve, reject) => {
                if (recaptchaReady) {
                    resolve();
                }
                else if (recaptchaLoadError !== null) {
                    reject(recaptchaLoadError);
                }
                else {
                    readyCallbacks.push({ resolve, reject });
                }
            });
        },
        renderV2: async function (container, siteKey, onSuccess) {
            await window.mcb.forms.recaptcha.whenReady();

            if (widgetIds.has(container)) {
                return widgetIds.get(container);
            }

            const options = {
                sitekey: siteKey
            };

            if (typeof onSuccess === 'function') {
                options.callback = onSuccess;
            }

            const widgetId = window.grecaptcha.render(container, options);

            widgetIds.set(container, widgetId);
            _logger.trace("Rendered reCAPTCHA v2 widget", widgetId);

            return widgetId;
        },
        hasV2Widget: function (container) {
            return widgetIds.has(container);
        },
        resetV2: function (container) {
            if (widgetIds.has(container)) {
                window.grecaptcha.reset(widgetIds.get(container));
            }
        },
        clearV2Widget: function (container) {
            widgetIds.delete(container);
            container.replaceChildren();
        }
    };
})();
